export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fbf0de9fdbd24563d21c80fc2d5187e6679de6671&name=fetchTypeahead!'